<template>
    <el-dialog title="功能设置" :close-on-click-modal="false" width="640px" :model-value="modelValue" @close="closed">
        <el-form ref="formRef" :model="formData" label-width="120px" style="max-width: 540px">
            <el-form-item label="功能选择">
                <div class="group" v-if="isForm">
                    <el-checkbox v-model="checked1" label="展开/折叠" size="large" />
                    <!-- <el-checkbox v-model="checked2" label="全选/全不全" size="large" /> -->
                    <el-checkbox v-model="checkStrictly" label="父子联动" size="large" />
                </div>
                <el-tabs v-model="currentModule" class="demo-tabs" @tab-click="handleClick" style="width: 100%">
                    <el-tab-pane
                        v-for="item in moduleOptionLists"
                        :label="item.name"
                        :name="item.id"
                        :key="item.id"
                    ></el-tab-pane>
                </el-tabs>
                <el-scrollbar v-if="isForm" style="height: 300px; overflow: auto; width: 100%">
                    <el-tree
                        ref="treeRef"
                        :data="allAuthsData"
                        show-checkbox
                        node-key="id"
                        :props="defaultProps"
                        :check-strictly="!checkStrictly"
                        @check="handleCheck"
                    ></el-tree>
                </el-scrollbar>
                <el-scrollbar v-else style="height: 300px; overflow: auto">
                    <el-tree
                        ref="userTreeRef"
                        :data="userAuthsData"
                        node-key="id"
                        default-expand-all
                        :props="defaultProps"
                    ></el-tree>
                </el-scrollbar>
            </el-form-item>
            <el-form-item label="备注">
                <el-input v-if="isForm" v-model="formData.remark" type="textarea"></el-input>
                <div v-else>{{ formData.remark }}</div>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, nextTick, ref, watch } from 'vue'
import { setSchoolFunctions } from '@/api/school'
import { getAuthTree } from '@/api/auth'
import { ElMessage } from 'element-plus'
import { getModuleOptionLists } from '@/api/module'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: true
    },
    roleId: {
        type: String,
        required: false
    },
    checkedAuths: {
        type: Array,
        default: () => []
    },
    checkedPartAuths: {
        type: Array,
        default: () => []
    }
})

const emits = defineEmits(['update:modelValue', 'updateForm'])

const checked1 = ref(false)
const checked2 = ref(false)
const checkStrictly = ref(true)

// 表单源
const formData = ref({
    auth_check_strictly: 1,
    auths: [],
    part_auths: []
})
const submitLoading = ref(false)
const formRef = ref(null)
const treeRef = ref(null)
// el-tree属性结构配置
const defaultProps = {
    children: 'children',
    label: 'name'
}
const allAuthsData = ref([])
const allAuthsDataId = ref([])
const dogetAuthTree = async (filter) => {
    allAuthsDataId.value = []

    // 递归：收集ID + 勾选节点
    const traverse = (data) => {
        data.forEach((ele) => {
            allAuthsDataId.value.push(ele.id)

            // 勾选符合条件的节点
            if (formData.value.auths.includes(ele.id)) {
                treeRef.value.setChecked(ele, true, false)
            }

            // 递归子节点
            if (ele.children) {
                traverse(ele.children)
            }
        })
    }

    allAuthsData.value = await getAuthTree({ mod: currentModule.value })
    await nextTick()

    // 一次遍历搞定
    traverse(allAuthsData.value)
}
const userTreeRef = ref(null)
const userAuthsData = ref([])

// 关闭
const closed = () => {
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
    treeRef.value && treeRef.value.setCheckedKeys([], false)
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    await doAddRole()
}

// 添加模块
const doAddRole = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const err = await setSchoolFunctions({
            id: props.roleId,
            auths: formData.value.auths,
            part_auths: formData.value.part_auths
        }).catch((err) => {
            submitLoading.value = false
            return err
        })
        if (err) return
        // 模块添加成功
        emits('updateForm')
        ElMessage.success('设置成功！')
        submitLoading.value = false
        closed()
    })
}

// 模块选项列表
const moduleOptionLists = ref([])
const currentModule = ref('')
// 获取数据的方法
const getModuleOptionListsData = async () => {
    const moduleOptionRes = await getModuleOptionLists({ without_base: 1 })
    moduleOptionLists.value = moduleOptionRes
    currentModule.value = moduleOptionRes[0].id
    await dogetAuthTree()
}
const handleClick = async (data) => {
    formData.value.auths = Array.from(new Set(formData.value.auths.concat(treeRef.value.getCheckedKeys())))
    formData.value.part_auths = Array.from(new Set(formData.value.part_auths.concat(treeRef.value.getHalfCheckedKeys())))
    currentModule.value = data.paneName
    await dogetAuthTree()
}

const handleCheck = (node, data) => {
    delCurrentAuth()
    formData.value.auths = formData.value.auths.concat(data.checkedKeys)
    formData.value.part_auths = formData.value.part_auths.concat(data.halfCheckedKeys)
}

const delCurrentAuth = () => {
    for (let i = 0; i < allAuthsDataId.value.length; i++) {
        const ele = allAuthsDataId.value[i]
        const checkedKeyIndex = formData.value.auths.findIndex((item) => item === ele)
        if (checkedKeyIndex > -1) {
            formData.value.auths.splice(checkedKeyIndex, 1)
        }
        const checkedHalfKeyIdex = formData.value.part_auths.findIndex((item) => item === ele)
        if (checkedHalfKeyIdex > -1) {
            formData.value.part_auths.splice(checkedHalfKeyIdex, 1)
        }
    }
}

// 只有roleId有的时候，才会去请求数据
watch(
    () => props.modelValue,
    async (newVal) => {
        if (newVal) {
            getModuleOptionListsData()
        }
        if (newVal && props.roleId) {
            formData.value.auths = props.checkedAuths
            formData.value.part_auths = props.checkedPartAuths
            if (treeRef.value) {
                await nextTick()
                setTimeout(() => {
                    treeRef.value.setCheckedKeys(props.checkedAuths)
                }, 500)
            }
        } else {
            // 置空
            formData.value = {
                name: '',
                code: '',
                auth_check_strictly: 1,
                auths: [],
                part_auths: [],
                list_order: 1,
                status: 1,
                visible: 1,
                remark: ''
            }
        }
    }
)

watch(checked1, (newVal) => {
    const treeNode = treeRef.value.store.nodesMap
    for (const item in treeNode) {
        treeNode[item].expanded = newVal
    }
})

watch(checked2, (newVal) => {
    if (newVal) {
        const treeNode = treeRef.value.store.nodesMap
        treeRef.value.setCheckedKeys(Object.keys(treeNode))
    } else {
        treeRef.value.setCheckedKeys([])
    }
})
</script>

<style lang="scss" scoped></style>
